import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import PlayPrensentationVideoDialog from "./PlayPrensentationVideoDialog";

const PresentationBuilder = ({
  presentations,
  setPresentations,
  addPresentation,
  addSlide,
  deletePresentation,
  deleteSlide,
  handlePresentationMinimize,
}) => {
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(null);
  const [selectedPresentation, setSelectedPresentation] = useState(null);
  const [selectedSlideData, setSelectedSlideData] = useState(null);
  const [isPlayVideoDialogVisible, setIsPlayVideoDialogVisible] =
    useState(false);

  return (
    <div>
      <div className="d-flex flex-column align-items-center">
        <h5 className="fw-bold text-center mb-3">PRESENTATION BUILDER</h5>
        <p className="text-muted text-center small w-50">
          Right-click or drag & drop video clips or chart images into the
          appropriate slide.
        </p>
      </div>
      <TabView className="transcript-tabs">
        <TabPanel header="Private" className="p-0"></TabPanel>
        <TabPanel header="Shared" className="p-0"></TabPanel>
      </TabView>
      {presentations.map((presentation, pIndex) => (
        <div
          key={pIndex}
          className="mt-3 rounded-3 py-3 mb-4 bg-light"
          style={{
            border: "2px dashed #dee2e6",
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="fw-bold m-0 ps-3">{presentation.name}</h6>
            <div>
              {presentation.isPresentationMinimise ? (
                <Button
                  icon="pi pi-window-maximize"
                  className="p-button-text p-button-sm"
                  onClick={() => handlePresentationMinimize(pIndex, false)}
                />
              ) : (
                <Button
                  icon="pi pi-minus"
                  className="p-button-text p-button-sm"
                  onClick={() => handlePresentationMinimize(pIndex, true)}
                />
              )}
              <Button
                icon="pi pi-clone"
                className="p-button-text p-button-sm"
              />
              <Button
                icon="pi pi-pencil"
                className="p-button-text p-button-sm"
              />
              <Button
                icon="pi pi-trash"
                className="p-button-text p-button-sm"
                onClick={() => deletePresentation(pIndex)}
              />
            </div>
          </div>
          {!presentation.isPresentationMinimise && (
            <>
              <div
                className="px-3"
                style={{ maxHeight: "490px", overflow: "auto" }}
              >
                {presentation.slides.map((slide, slideIdx) => (
                  <div key={slideIdx}>
                    <div
                      className="rounded-2 p-3 mb-4 bg-white position-relative"
                      style={{
                        border: "2px dashed #dee2e6",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>{slide.slideName}</strong>
                        <div>
                          <Button
                            icon="pi pi-clone"
                            className="p-button-text p-button-sm me-2"
                          />
                          <Button
                            icon="pi pi-pencil"
                            className="p-button-text p-button-sm"
                          />
                          <Button
                            icon="pi pi-trash"
                            className="p-button-text p-button-sm"
                            onClick={() => deleteSlide(pIndex, slideIdx)}
                          />
                        </div>
                      </div>
                      {slide.slideVideos.length ? (
                        <div className="position-relative mt-3">
                          <div
                            className="d-flex overflow-auto pb-3"
                            style={{
                              scrollBehavior: "smooth",
                              gap: "0.5rem",
                              whiteSpace: "nowrap",
                              backgroundColor: "transparent",
                            }}
                          >
                            {slide.slideVideos?.map((s, i) => (
                              <div
                                key={i}
                                className={`card text-center flex-shrink-0 ${
                                  selectedSession === i ? "active" : ""
                                }`}
                                style={{
                                  width: "215px",
                                  height: "120px",
                                  border: "2px solid #999",
                                  cursor: "pointer",
                                  borderRadius: "0",
                                  opacity: selectedSession === i ? 1 : 0.6,
                                }}
                                onClick={() => {
                                  setIsPlayVideoDialogVisible(true);
                                  setSelectedPresentation(pIndex);
                                  setSelectedSlideIndex(slideIdx);
                                  setSelectedSlideData(slide);
                                }}
                              >
                                <div className="card-body p-0">
                                  <div
                                    className="position-relative"
                                    style={{
                                      backgroundColor: "#f8f9fa",
                                      height: "81px",
                                    }}
                                  >
                                    {/* Play icon overlay */}
                                    <i
                                      className="pi pi-play-circle"
                                      style={{
                                        fontSize: "2.5rem",
                                        color: "#007bff",
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                      }}
                                    />
                                  </div>
                                  <div className="mt-2 text-truncate">
                                    <strong>{s.name}</strong> - {s.title}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="border border-dashed rounded p-3 text-center text-muted">
                          (Drop video or image here)
                        </div>
                      )}
                      <div
                        className="previewClipOuter"
                        style={{
                          position: "absolute",
                          bottom: "-15px",
                        }}
                      >
                        <Button
                          className="p-button-sm px-2 py-1 fs-12 rounded createClientBtn"
                          onClick={() => {
                            setIsPlayVideoDialogVisible(true);
                            setSelectedPresentation(pIndex);
                            setSelectedSlideIndex(slideIdx);
                            setSelectedSlideData(slide);
                          }}
                        >
                          <i className="pi pi-play fs-12 me-1"></i>
                          <span>Play All</span>
                        </Button>
                      </div>

                      <div className="previewClipOuter">
                        <Button
                          className="p-button-sm px-2 py-1 fs-12 timedingBtn"
                          onClick={() => {
                            setIsPlayVideoDialogVisible(true);
                            setSelectedPresentation(pIndex);
                            setSelectedSlideIndex(slideIdx);
                            setSelectedSlideData(slide);
                          }}
                        >
                          <i className="pi pi-stopwatch fs-12 me-1 fw-600"></i>
                          <span>Timings</span>
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="p-3">
                <div
                  className="rounded-2 p-3 d-flex align-items-center justify-content-center"
                  style={{
                    border: "2px dashed #dee2e6",
                  }}
                >
                  <i className="pi pi-plus" />
                  <Button
                    label="NEW SLIDE"
                    link
                    className="p-button-sm"
                    onClick={() => addSlide(presentation.id)}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      ))}

      <div
        className="rounded-2 p-3 d-flex align-items-center justify-content-center mt-3"
        style={{
          border: "2px dashed #dee2e6",
        }}
      >
        <i className="pi pi-plus" />
        <Button
          label="NEW PRESENTATION"
          link
          className="p-button-sm"
          onClick={addPresentation}
        />
      </div>

      <div className="d-flex align-items-center justify-content-center">
        <Button
          label="REVIEW PRESENTATION"
          className="createClientBtn rounded-2 my-4"
          onClick={() => alert("Reviewing presentation")}
        />
      </div>

      {isPlayVideoDialogVisible ? (
        <PlayPrensentationVideoDialog
          selectedSlideData={selectedSlideData}
          headerName={selectedSlideData?.slideName}
          isPlayVideoDialogVisible={isPlayVideoDialogVisible}
          setSelectedPresentation={setSelectedPresentation}
          setSelectedSlideIndex={setSelectedSlideIndex}
          setIsPlayVideoDialogVisible={setIsPlayVideoDialogVisible}
          setSelectedSlideData={setSelectedSlideData}
        />
      ) : null}
    </div>
  );
};

export default PresentationBuilder;
